import gql from 'graphql-tag'

export const UPDATE_ORDERPART = gql`
  mutation updateOrderPart($data: UpdateOrderPartInput!) {
    updateOrderPart(data: $data) {
      id
      amount
    }
  }
`

export const SUBMIT_ORDER = gql`
  mutation submitOrder($data: SubmitOrderInput!) {
    submitOrder(data: $data) {
      id
      submitted
    }
  }
`

export const SUBMIT_OCI_ORDER = gql`
  mutation submitOCIOrder($data: SubmitOCIOrderInput!) {
    submitOCIOrder(data: $data) {
      id
      submitted
    }
  }
`

export const UPDATE_BRANCH = gql`
  mutation updateBranch($data: UpdateBranchInput!) {
    updateBranch(data: $data) {
      id
      phone
      altPhone
      email
      website
    }
  }
`

export const DELETE_USER = gql`
  mutation deleteUser($data: DeleteUserInput!) {
    deleteUser(data: $data) {
      id
      gender
      firstName
      insertion
      lastName
      email
      phone
      altPhone
      branches {
        id
        name
      }
    }
  }
`

export const CREATE_USER = gql`
  mutation CreateUser($data: CreateUserInput!) {
    createUser(data: $data) {
      id
      gender
      firstName
      insertion
      lastName
      email
      phone
      altPhone
      permissions
      role
      username
      contactCode
      loginTimeStamp
      branches {
        id
        name
      }
    }
  }
`

export const ACTIVATE_USER = gql`
  mutation activateUser($data: ActivateUserInput!) {
    activateUser(data: $data) {
      id
      token
      user {
        id
        branches {
          name
          address
          zipcode
          city
          id
        }
      }
    }
  }
`

export const EDIT_USER = gql`
  mutation editUser($data: UpdateUserInput!) {
    updateUser(data: $data) {
      id
      gender
      firstName
      insertion
      lastName
      email
      phone
      altPhone
      permissions
    }
  }
`

export const UPDATE_PERMISSIONS = gql`
  mutation updatePermissions($data: UpdatePermissionsInput!) {
    updatePermissions(data: $data) {
      id
      gender
      firstName
      insertion
      lastName
      email
      phone
      altPhone
      permissions
    }
  }
`

export const EDIT_SELF = gql`
  mutation editSelf($data: UpdateSelfInput!) {
    updateSelf(data: $data) {
      id
      firstName
      insertion
      lastName
      email
      phone
      altPhone
    }
  }
`

export const UPDATE_PASSWORD = gql`
  mutation updatePassword($data: UpdatePasswordInput!) {
    updatePassword(data: $data) {
      id
    }
  }
`

export const REPORT_ERROR = gql`
  mutation reportError($data: ReportErrorInput!) {
    reportError(data: $data) {
      branch
      message
    }
  }
`

export const SEND_CONTACT = gql`
  mutation sendContactForm($data: SendContactFormInput!) {
    sendContactForm(data: $data) {
      branch
      message
    }
  }
`

export const SEND_ACTIVATION_MAIL = gql`
  mutation sendActivationMail($data: SendActivationMailInput!) {
    sendActivationMail(data: $data) {
      message
    }
  }
`

export const SEND_PASSWORD_MAIL = gql`
  mutation sendPasswordMail($data: SendPasswordMailInput!) {
    sendPasswordMail(data: $data) {
      id
    }
  }
`

export const RESET_PASSWORD = gql`
  mutation resetPassword($data: ResetPasswordInput!) {
    resetPassword(data: $data) {
      id
    }
  }
`

export const LOGIN_MUTATION = gql`
  mutation LoginMutation($data: LoginInput!) {
    login(data: $data) {
      token
      user {
        id
        firstName
        insertion
        lastName
        branches {
          name
          address
          zipcode
          city
          id
        }
      }
    }
  }
`

export const CREATE_PORTAL_ORDER = gql`
  mutation createPortalOrder($data: CreatePortalOrderInput!) {
    createPortalOrder(data: $data) {
      id
      submitted
    }
  }
`

export const CREATE_NEW_PORTAL_ORDER = gql`
  mutation createNewPortalOrder($data: CreateNewPortalOrderInput!) {
    createNewPortalOrder(data: $data) {
      id
      submitted
    }
  }
`

export const DELETE_PORTAL_ORDER = gql`
  mutation deletePortalOrder($data: DeletePortalOrderInput!) {
    deletePortalOrder(data: $data) {
      id
    }
  }
`

export const REPEAT_ORDER = gql`
    mutation repeatOrder($data: UpdatePortalOrderInput!) {
    updatePortalOrder(data: $data) {
      id
    }
  }
`



// WEBPACK FOOTER //
// ./src/mutations.js